module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', [_c('hospital-select', {
    on: {
      "selected": _vm.selectHospital
    }
  }), _vm._v(" "), _c('voucher-select', {
    attrs: {
      "list": _vm.voucherList
    },
    on: {
      "selected": _vm.selectVoucher
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "thick",
    staticStyle: {
      "margin-top": "0.3rem"
    }
  }, [_c('ul', {
    staticClass: "tab-top"
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('li', {
      staticClass: "tab-item",
      class: {
        active: _vm.selectedTab.tabId == item.tabId
      },
      attrs: {
        "id": 'register-departDoctor-tab-' + item.tabId
      },
      on: {
        "click": function($event) {
          return _vm.onSelectedTab(index)
        }
      }
    }, [_c('span', {
      staticClass: "tab-label"
    }, [_vm._v(_vm._s(item.tabName))])])
  }), 0)]), _vm._v(" "), _c('div', _vm._l((_vm.waitInfo), function(item, index) {
    return _c('ul', {
      staticClass: "wait-list"
    }, [_c('li', [_c('span', {
      staticClass: "left"
    }, [_vm._v("科室/诊室")]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.deptName))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "left"
    }, [_vm._v("就诊医生")]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.doctName))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "left"
    }, [_vm._v("正在就诊号")]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.currentNo))])]), _vm._v(" "), _c('li', [_c('span', {
      staticClass: "left"
    }, [_vm._v("我的就诊号")]), _vm._v(" "), _c('span', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.waitNo) + "号\n            "), (item.status == '1') ? _c('span', {
      class: {
        green: item.status == '1'
      }
    }, [_vm._v("(等待中)")]) : _vm._e(), _vm._v(" "), (item.status == '2') ? _c('span', {
      class: {
        green: item.status == '2'
      }
    }, [_vm._v("(叫号中)")]) : _vm._e(), _vm._v(" "), (item.status == '3') ? _c('span', {
      class: {
        gray: item.status == '3'
      }
    }, [_vm._v("(过号)")]) : _vm._e()])])])
  }), 0), _vm._v(" "), _c('no-record', {
    attrs: {
      "id": "myregister-norecord",
      "condition": _vm.waitInfo,
      "tips": "抱歉，没有候诊记录"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8f7ff2e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/waitDoctor/WaitDoctor.vue
// module id = 877
// module chunks = 0